<template>
  <transition name="router-anim">
    <div class="kits">
      <div class="state-wrap">
        <div class="description-icon">
          <DescriptionModal class="description-modal" :description="'This page is for calculating kit generation and displaying inventory distribution.'" />
        </div>
        <div class="pl-32">
          <KitPercentageForm 
            @updateSubmitted="updateSubmitted"
            @clearInventory="clearInventory"
          />
        </div>
      </div>
      <!-- <div class="state-wrap" v-if="showFilter && (fillocation == null || fillocation == '') ">
        <div class="kits-title-header">
          <div class="title-header">
            <p class="max-kits-error">Please select the region from the above filter to see the maximum number of kits that can be generated.</p>
          </div>
        </div>
      </div> -->
      <div>
        <!-- <div class="state-wrap" v-if="showFilter"> 
          <div class="kits-title-header">
            <div class="title-header">
              <p class="max-kits" v-if="maxKits.type != null"> The maximum number of {{maxKits.type}} kits that can be generated: {{ maxKits.value}}</p>
            </div>
          </div>
        </div> -->
        <div class="table-container cus-padd">
          <p class="inventory-title pl-20 pt-20 mt-20">Total Inventory Distribution</p>
          <div class="table-wrapper gap-5">
            <div class="kit-type-wrapper">
              <table class="styled-table">
                  <thead>
                      <tr>
                          <th class="title-data">Loc
                            <span class="sort-data date" @click="sortedBy('location')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_location === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data">Item Description
                            <span class="sort-data date" @click="sortedBy('item_description')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_item_description === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data">SKU
                            <span class="sort-data date" @click="sortedBy('sku')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_sku === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data text-right">Units Needed
                            <span class="sort-data date" @click="sortedBy('reserved')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_reserved === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data text-right">Unit Price
                            <span class="sort-data date" @click="sortedBy('units_per_price')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_units_per_price === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data text-right">Total Price
                            <span class="sort-data date" @click="sortedBy('total_price')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_total_price === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data text-right">Total Invy
                            <span class="sort-data date" @click="sortedBy('total_inventory')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_total_inventory === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                          <th class="title-data text-right">Remaining Invy
                             <!-- Question mark with tooltip -->
                            <span class="tooltip-container">
                              <img
                                class="icon-tooltip"
                                src="../../images/dashboard/info.png"
                                alt="i"
                              />
                              <span class="tooltip-text">
                                <p>Red: If the remaining inventory is less than 10% of the total inventory.</p><br>
                                <p>Yellow: If the remaining inventory is between 10% and 50% of the total inventory.</p><br>
                                <p>Green: If the remaining inventory is greater than 50% of the total inventory.</p>
                              </span>
                            </span>
                            <span class="sort-data date" @click="sortedBy('available_inventory')">
                              <img
                                class="img-sort"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-if="sortedBy_available_inventory === 'desc'"
                              />
                              <img
                                class="img-sort down"
                                src="../../images/dashboard/up.png"
                                alt="#"
                                v-else
                              />
                            </span>
                          </th>
                      </tr>
                  </thead>
                  <tbody v-if="inventory.length > 0 && submitted">
                      <tr class="inv-item" v-for="(item,index) in inventory" :key="index">
                          <td class="kit-desc">{{ item.location }}</td>
                          <td class="kit-desc">{{ item.item_description }}</td>
                          <td class="kit-desc sku-cell">
                            <span class="sku-link-wrap" @click="viewSkuDetail(item.sku, item.item_description)" title="View SKU Details">
                              <code>{{ getSkuDisplayName(item) }}</code>
                              <button class="eye-icon-btn" @click.stop="viewSkuDetail(item.sku, item.item_description)" title="View SKU Details">👁️</button>
                            </span>
                          </td>
                          <td class="kit-desc text-right">{{ item.reserved}}</td>
                          <td class="kit-desc text-right">{{ parseFloat(item.units_per_price).toFixed(2) }}</td>
                          <td class="kit-desc text-right">{{ parseFloat(item.total_price).toFixed(2)}}</td>
                          <td class="kit-desc text-right">{{ item.total_inventory}}</td>
                          <td class="kit-desc text-right" :style="{ color: calculateColor( item.available_inventory , item.reserved ) }">{{ item.available_inventory }}
                            <span
                              class="edit-kit-btn"
                              @click="edit(item)"
                              title="Edit"
                              v-show="!showFilter"
                            >
                              <img
                                src="../../images/dashboard/icons8-edit-100.png"
                              />
                            </span>
                          </td>
                      </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="8" class="kit-desc text-center">No Data Retrieved.</td>
                    </tr>
                  </tbody>
              </table>
            </div>
          </div>
      </div> 
        <!-- <div class="kits-title" :class="computedClass">
          <div class="title-data  location">
            Loc
            <div class="sort-data  date" @click="sortedBy('location')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_location === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  item-description">
            Item Description
            <div class="sort-data  date" @click="sortedBy('item_description')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_item_description === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  sku">
            SKU
            <div class="sort-data  date" @click="sortedBy('sku')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_sku === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  reserved"  v-if="fillocation != null && fillocation != ''">
            Units Needed
            <div class="sort-data  date" @click="sortedBy('reserved')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_reserved === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  units-per-price">
            Unit Price
            <div class="sort-data  date" @click="sortedBy('units_per_price')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_units_per_price === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  total-price" v-if="fillocation != null && fillocation != ''">
            Total Price
            <div class="sort-data  date" @click="sortedBy('total_price')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_total_price === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  available-invendory">
            Total Invy 
            <div class="sort-data  date" @click="sortedBy('total_inventory')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_total_inventory === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
          <div class="title-data  available-invendory">
            Remaining Invy 
            <div class="sort-data  date" @click="sortedBy('available_inventory')">
              <img
                src="../../images/dashboard/up.png"
                alt="#"
                v-if="sortedBy_available_inventory === 'desc'"
              />
              <img
                class="down"
                src="../../images/dashboard/up.png"
                alt="#"
                v-else
              />
            </div>
          </div>
        </div>
        <div v-if="inventory.length > 0 && submitted">
          <div class="kits-item"  v-for="(item,index) in inventory"   :key="index" >
              <div
                class="kit-desc location"
              >
                {{ item.location }}
              </div>
              <div
                class="kit-desc item-description"
              >
                {{ item.item_description }}
              </div>
              <div class="kit-desc sku">
                {{ item.sku }}
              </div>
              <div class="kit-desc reserved" v-if="fillocation != null && fillocation != ''">
                <span>{{ item.reserved}}</span>
              </div>
              <div class="kit-desc units-per-price">
                <span>{{ parseInt(item.units_per_price).toFixed(2) }}</span>
              </div>
              <div class="kit-desc total-price" v-if="fillocation != null && fillocation != ''">
                <span>{{ parseInt(item.total_price).toFixed(2)}}</span>
              </div>
              <div class="kit-desc available_inventory" v-if="fillocation != null && fillocation != ''">
                <span>{{ item.total_inventory}}</span>
              </div>
              <div class="kit-desc available_inventory" :style="{ color: calculateColor( item.available_inventory , item.reserved ) }">
                <span>{{ item.available_inventory }}</span>
              </div>
              <div class="kit-desc">
                  <div
                    class=" kit-desc edit-kit-btn"
                    @click="edit(item)"
                    title="Edit"
                    v-show="!showFilter"
                  >
                    <img
                      src="../../images/dashboard/icons8-edit-100.png"
                    />
                  </div>
              </div>
            </div>
        </div>
        <div v-else class="kits-item">
          <div class="kit-desc nodata">
            No Data Retrieved.
          </div>
        </div> -->
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import KitPercentageForm from "../dashboard/KitPercentageForm";
import Paginate from "vuejs-paginate";
import Remove from "../../images/dashboard/Remove";

export default {
  name: "InventoryManagement",
  data() {
    return {
      inventory: [],
      //count_page: 1,
      sortedBy_location: "desc",
      sortedBy_item_description: "desc",
      sortedBy_sku: "desc",
      sortedBy_units_per_price: "desc",
      sortedBy_total_price : "desc",
      sortedBy_reserved: "desc",
      sortedBy_available_inventory: "desc",
      sortedBy_total_inventory: "desc",
      sortedByColumn: '',
      maxKits : {},
      showFilter: false,
      locations: [],
      selectedLocation: '',
      fillocation: null,
      fillitem: null,
      submitted: false,
      colors: {
        blue: '#005EB8',
        gray: '#373737',
        yellow: '#F1B434',
        green: '#43B02A',
        red: '#E10E49',
      },
    };
  },
  components: {
    KitPercentageForm,
    Remove,
    Paginate
  },
  methods: {
    ...mapActions([
      "setInventory",
      "setPage",
      'setFillocation'
    ]),
    // handleLocationChange(){
    //   this.loading = true;
    //   this.setPage(1);
    //   this.setFillocation(this.selectedLocation).then(async res => {})
    //   this.loading = false;
    // },
    calculatePercentage(available_inventory, reserved) {
      // Calculate the percentage of available inventory out of the total
      const total = available_inventory + reserved;
      return total ? ((available_inventory / total) * 100).toFixed(2) : 0;
    },
    calculateColor(available_inventory, reserved) {
      const percentage = this.calculatePercentage(parseInt(available_inventory), parseInt(reserved));
      if (percentage <= 10) {
        return this.colors.red;
      } else if (percentage > 10) {
        return this.colors.green;
      }
    },
    back(){
      this.$emit("back", false);
    },
    getSkuDisplayName(item) {
      if (!item) return "";
      const sku = item.sku || "";
      const desc = item.item_description || "";
      if (desc && sku) {
        return `${desc} (${sku})`;
      }
      return desc || sku || "N/A";
    },
    viewSkuDetail(sku, itemDescription) {
      if (!sku) return;
      const query = {};
      if (itemDescription) {
        query.description = itemDescription;
      }
      this.$router.push({ name: "SkuDetail", params: { sku }, query });
    },
    edit(item){
      this.$emit("editAddInv", {
        show: true,
        item:item,
      });
    },
    calculateTotal(quantity, price) {
      return  parseFloat((quantity * price ).toFixed(2));
    },
    changePage(item) {
      this.setPage(item).then(res => {
        this.setInventory();
      });
    },
    // sortedBy(column) {
    //   if (this.sortedBy_[column] === "desc") {
    //     this.sortedBy_[column] = "asc";
    //   } else {
    //     this.sortedBy_[column] = "desc";
    //   }
    //   this.setInvOrderBy(column);
    //   this.setInvSortedBy(this.sortedBy_[column]).then(() => {
    //     this.setInventory("admins");
    //   });
    // },
    sortedBy(key) {
      const sortProperty = `sortedBy_${key}`;
      if (this[sortProperty] === "desc") {
        this[sortProperty] = "asc";
      } else {
        this[sortProperty] = "desc";
      }
      this.inventory.sort((a, b) => {
        if (a[key] < b[key]) {
          return this[sortProperty] === "asc" ? -1 : 1;
        }
        if (a[key] > b[key]) {
          return this[sortProperty] === "asc" ? 1 : -1;
        }
        return 0;
      });
    },
    // sortedBy(column) {
    //   if (this.sortedByColumn === column) {
    //     // Toggle sorting order if the same column is clicked again
    //     this.sortedBy_sku = this.sortedBy_sku === 'asc' ? 'desc' : 'asc';
    //   } else {
    //     // Sort by a new column
    //     this.sortedByColumn = column;
    //     this.sortedByState = 'asc'; // Start with ascending order
    //   }
      
    //   // Sort inventory array based on the column and order
    //   this.inventory.sort((a, b) => {
    //     let compareA = a[column];
    //     let compareB = b[column];
        
    //     // Handle potential null or undefined values
    //     if (compareA === null || compareA === undefined) compareA = '';
    //     if (compareB === null || compareB === undefined) compareB = '';
        
    //     // Convert to lowercase if the value is a string for case-insensitive sorting
    //     if (typeof compareA === 'string') compareA = compareA.toLowerCase();
    //     if (typeof compareB === 'string') compareB = compareB.toLowerCase();
        
    //     if (this.sortedByState === 'asc') {
    //       return compareA > compareB ? 1 : compareA < compareB ? -1 : 0;
    //     } else {
    //       return compareA < compareB ? 1 : compareA > compareB ? -1 : 0;
    //     }
    //   });
    // },
    remove(id, firstName, lastName) {
      this.$emit("confirmDelLabOps", {
        show: true,
        id,
        fullname: `${firstName} ${lastName}`
      });
    },
    date(localDate) {
      return localDate;
      // if (localDate) {
      //   let date = new Date(localDate);
      //   return moment(date).format("MM/DD/YYYY");
      // }
    },
    updateSubmitted(value) {
      this.submitted = value;
    },
    clearInventory() {
      this.inventory = [];
    }
  },
  computed: {
    ...mapGetters(["getInventory",'getPaginations','getMaxKit', 'getFillocation','getFilItem']),
    computedClass() {
      if (this.fillocation == null || this.fillocation == '' || this.fillitem == null || this.fillitem == '') {
        return 'title-inv';
      } else {
        return 'title'; // Replace with your "else" class
      }
    }
  },
  watch: {
    // getPaginations(num) {
    //   this.count_page = num;
    // },
    getFillocation(loc){
      this.fillocation = loc;
    },
    getFilItem(obj){
      this.fillitem = obj;
    },
    getMaxKit(num) {
      this.maxKits  = num;
    },
    getInventory(obj) {
      this.inventory = obj;
    }
  },
  mounted() {
   this.locations = this.$store.getters.getLocation;
   this.maxKits  = this.$store.getters.getMaxKit;
   this.inventory = this.$store.getters.getInventory;
   this.showFilter = this.$store.getters.getInvKit;
   this.fillItem = this.$store.getters.getFilItem;
   this.fillocation = this.$store.getters.getFillocation;
   if(!this.showFilter) {
    this.submitted = true;
   }
  //  if (this.$store.getters.getPagination !== null) {
  //    this.count_page = this.$store.getters.getPagination;
  //   }
  }
};
</script>

<style scoped>
.kits {
  margin: 10px 0 0 0;
}
.kits-title {
  display: flex;
  justify-content: space-between;
  margin: 0 0 30px 0;
  padding: 0 30px;
}
.title-data {
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.kits-title-header{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 30px;
}
.title-header {
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
}
.title .location {
  min-width: 100px;
  width: 100%;
  max-width: 117px;
}
.title-inv .location {
  min-width: 100px;
  width: 100%;
  max-width: 100px;
}
.kit-desc.location {
  min-width: 100px;
  width: 100%;
  cursor: pointer;
  max-width: 117px;
}
.title-inv .item-description {
  min-width: 100px;
  width: 100%;
  max-width: 190px;
}
.title .item-description {
  min-width: 100px;
  width: 100%;
  max-width: 180px;
}
.kit-desc.item-description {
  min-width: 100px;
  width: 100%;
  max-width: 180px;
  cursor: pointer;
}
.title-inv .sku {
  min-width: 80px;
  width: 100%;
  max-width: 80px;
}
.title .sku {
  min-width: 80px;
  width: 100%;
  max-width: 80px;
}
.kit-desc.sku {
  min-width: 100px;
  width: 100%;
  max-width: 120px;
  cursor: pointer;
}
.title-inv .units-per-price {
  min-width: 100px;
  width: 100%;
  max-width: 100px;
}
.title .units-per-price {
  min-width: 100px;
  width: 100%;
  max-width: 100px;
}
.kit-desc.units-per-price {
  min-width: 100px;
  width: 100%;
  max-width: 100px;
  cursor: pointer;
  text-align: right;
}
.title .total-price {
  min-width: 70px;
  max-width: 70px;
  width: 100%;
}
.kit-desc.total-price {
  min-width: 100px;
  max-width: 100px;
  width: 100%;
  cursor: pointer;
  text-align: right;
}
.title .reserved {
  min-width: 150px;
  max-width: 150px;
  width: 100%;
}
.kit-desc.reserved {
  min-width: 100px;
  max-width: 100px;
  width: 100%;
  cursor: pointer;
  text-align: right;
}
.title-inv .available_inventory {
  min-width: 100px;
  width: 100%;
  max-width: 100px;
}
.title .available_inventory {
  min-width: 100px;
  max-width: 100px;
  width: 100%;
}
.kit-desc.available_inventory {
  min-width: 100px;
  max-width: 100px;
  width: 100%;
  cursor: pointer;
  text-align: right;
}
.title .date {
  width: 10px;
  cursor: pointer;
}
.title .date img {
  max-width: 7px;
  height: 14px;
}
.title-inv .date img {
  max-width: 7px;
  height: 14px;
}

.title-inv .date {
  width: 10px;
  cursor: pointer;
}

.kit-desc.date {
  padding: 0 20px 0 0;
  min-width: 160px;
  width: 100%;
}
.kits-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #fff;
  margin: 10px 0;
  border-radius: 5px;
}
.kits-item:hover {
  background-color: #e0e9f4;
}
.kit-desc {
  font-size: 14px;
  font-family: TTNormsLight, sans-serif;
}
.remove-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
  border: none;
  outline: none;
  width: 10px;
}
.pogination {
  margin: 20px 0 0 0;
}

.kit-desc.nodata {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  text-align: center;
}
.kits-item:hover .edit-kit-btn {
 display: block;
}
.inv-item:hover .edit-kit-btn {
 display: inline;
}
.edit-kit-btn {
  display: none;
  cursor: pointer;
  cursor: pointer;
  margin-right: -10px;
}
.edit-kit-btn img{
  height: 14px;
}
.state-wrap {
  position: relative;
  background-color: #fff;
  padding: 25px 32px 30px 32px;
  margin-bottom: 30px;
  border-radius: 10px;
}
.max-kits{
  padding-bottom: 10px;
}
.max-kits-error{
  padding-bottom: 10px;
  color: #8b5e00;
}

.filter-wrap-custom {
  display: inline-flex;
  align-items: center;
  margin-bottom: 0px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: 1px solid transparent;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
  padding: 6px 15px 6px 15px;
  height: 30px;
  margin: 0 0 0 13px;
  cursor: pointer;
  border-radius: 5px;
}
.btn-test {
  background-color: #005eb8;
  color: #fff;
  max-width: 128px;
  width: 100%;
}
.sort-data{
  padding-left: 10px;
}
.sort-data.date .down {
  transform: rotate(180deg);
}
.input-filter {
  padding: 5px 10px;
  color: #373737;
  width: 100%;
  font-size: 16px;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsLight, sans-serif;
  background: white;
}
.table-container {
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: initial;
  font-size: 14px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.img-sort {
  width: 10px;
}
.inventory-title {
  font-family: TTNormsMedium, sans-serif;
  padding-bottom: 10px;
  color: #005eb8;
  font-size: 20px;
  font-weight: bold;
}
.pl-20 {
  padding-left: 20px;
}
.pt-20 {
  padding-top: 20px;
}
.mt-20 {
  margin-top: 20px !important;
}
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-left: 1px;
  top: 3px;
}
.tooltip-text {
  visibility: hidden;
  width: 15rem;
  background-color: #555;
  color: #fff;
  text-align: left;
  border-radius: 6px;
  padding: 5px 8px;
  position: absolute;
  z-index: 1;
  bottom: 2rem; /* Position above the icon */
  left: 50%;
  margin-left: -8rem; /* Center the tooltip */
  opacity: 0;
  transition: opacity 0.3s;
}
.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}
.icon-tooltip {
  width: 16px; /* Adjust size as needed */
  height: 16px;
}
.description-icon {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 5;
}
.pl-32 {
  padding-left: 0px;
}
.description-modal{
  display: inline-block;
  width: auto;
  position: static;
}

.sku-link-wrap {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
}

.sku-link-wrap:hover code {
  color: #005eb8;
  text-decoration: underline;
}
</style>
